import Navbar from './components/Navbar';
import Hero from './components/Hero';
import TodayFeed from './components/TodayFeed';
import Collections from './components/Collections';
import Packs from './components/Packs';
import CommentsZone from './components/CommentsZone';
import CtaBand from './components/CtaBand';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="w-full bg-background-50">
      <Navbar />
      <main className="w-full">
        <Hero />
        <TodayFeed />
        <Collections />
        <Packs />
        <CommentsZone />
        <CtaBand />
      </main>
      <Footer />
    </div>
  );
}